import React from "react";
import { Translate } from "react-thunk-i18nify";

import PropTypes from "prop-types";

const AvailableAgentSelection = ({ selectedAgents, handleAgentSelection }) => {
  if (selectedAgents === 0) return null;

  return (
    <div className="selected-employee d-flex justify-content-between align-items-center p-2 flex-wrap">
      <p className="mb-0 number-of-selected-employee">
        <Translate value="callQueue.agentManagement.selectedDevices" />
        <b className="count-of-employee ms-1">{selectedAgents}</b>
      </p>
      <button
        onClick={handleAgentSelection}
        className="btn btn-primary fw-normal d-none d-md-flex align-items-center"
        type="button"
      >
        <Translate value="callQueue.agentManagement.addSelectedToRegisteredAgents" />
      </button>
      <button
        onClick={handleAgentSelection}
        className="btn btn-primary fw-normal d-flex d-md-none align-items-center"
        type="button"
      >
        <Translate value="callQueue.agentManagement.addSelectedAgent" />
      </button>
    </div>
  );
};

AvailableAgentSelection.defaultProps = {
  selectedAgents: 0,
  handleAgentSelection: () => {},
};

AvailableAgentSelection.propTypes = {
  selectedAgents: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleAgentSelection: PropTypes.func,
};

export default AvailableAgentSelection;
